// extracted by mini-css-extract-plugin
export default {"numero":"Contador_numero__WuFwk"};